//home/krisz/Education/React/mountains/src/utils/helmet.js
(function () {
  // Graceful wrapper around react-helmet-async.
  // If the library is installed, we re-export its Helmet and HelmetProvider.
  // If it's not installed, we export no-op fallbacks so the app still runs.

  // Attempt a dynamic require without letting the bundler statically resolve it.
  // This avoids build-time failures when the package is absent.
  const safeRequire = (name) => {
    try {
      // eslint-disable-next-line no-new-func
      const req = (0, Function)('return typeof require==="function"?require:null;')();
      if (!req) return null;
      return req(name);
    } catch (_) {
      return null;
    }
  };

  const mod = safeRequire('react-helmet-async');

  const NoopHelmet = function NoopHelmet() {
    // Intentionally render nothing to avoid dropping <title>/<meta> into the body.
    return null;
  };

  const NoopHelmetProvider = function NoopHelmetProvider(props) {
    // Just render children; no head management performed.
    return props && props.children ? props.children : null;
  };

  // Prefer real components if available, otherwise fall back to no-ops.
  const Helmet = mod && mod.Helmet ? mod.Helmet : NoopHelmet;
  const HelmetProvider = mod && mod.HelmetProvider ? mod.HelmetProvider : NoopHelmetProvider;

  if (!mod) {
    // Helpful runtime hint (only once) to explain missing head updates.
    if (typeof window !== 'undefined' && !window.__NO_HELMET_WARNED__) {
      window.__NO_HELMET_WARNED__ = true;
      // eslint-disable-next-line no-console
      console.warn(
        '[helmet] react-helmet-async not found. Head updates (title, meta) are disabled. ' +
          'Install it with: npm install react-helmet-async'
      );
    }
  }

  // Support both ESM and CJS consumers from this wrapper.
  // ESM named exports
  try {
    Object.defineProperty(exports, '__esModule', { value: true });
  } catch (_) {
    // ignored if not in CJS
  }

  exports.Helmet = Helmet;
  exports.HelmetProvider = HelmetProvider;
  exports.isHelmetAvailable = !!mod;

  // Default export for convenience
  exports.default = { Helmet, HelmetProvider, isHelmetAvailable: !!mod };
})();
